export const defaultHotkeys = [
  {
    id: "switch_to_label",
    description: "Go to Labels Tab",
    binding: "shift+3",
  },
  {
    id: "switch_to_setup",
    description: "Go to Setup Tab",
    binding: "shift+1",
  },
  {
    id: "switch_to_samples",
    description: "Go to Samples Tab",
    binding: "shift+2",
  },
  {
    id: "select_tool",
    description: "Switch to the Select Tool",
    binding: "escape",
  },
  {
    id: "zoom_tool",
    description: "Select the Zoom Tool",
    binding: "z",
  },
  {
    id: "create_point",
    description: "Create a point",
  },
  {
    id: "create_bounding_box",
    description: "Create a bounding box",
    binding: "b",
  },
  {
    id: "pan_tool",
    description: "Select the Pan Tool",
    binding: "p",
  },
  {
    id: "create_polygon",
    description: "Create a Polygon",
  },
  {
    id: "create_pixel",
    description: "Create a Pixel Mask",
  },
  {
    id: "save_and_previous_sample",
    description: "Save and go to previous sample",
    binding: "a",
  },
  {
    id: "save_and_next_frame",
    description: "Save and go to next frame",
    binding: "r",
  },
  {
    id: "save_and_previous_frame",
    description: "Save and go to previous frame",
    binding: "e",
  },
  {
    id: "save_and_next_sample",
    description: "Save and go to next sample",
    binding: "d",
  },
  {
    id: "save_and_exit_sample",
    description: "Save and exit current sample",
  },
  {
    id: "exit_sample",
    description: "Exit sample without saving",
  },
]
export default defaultHotkeys
